import { render, staticRenderFns } from "./SendMessageHistory.vue?vue&type=template&id=1885e89d&scoped=true&lang=pug"
import script from "./SendMessageHistory.vue?vue&type=script&lang=ts"
export * from "./SendMessageHistory.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageHistory.vue?vue&type=style&index=0&id=1885e89d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1885e89d",
  null
  
)

export default component.exports